module.exports = __webpack_public_path__ + "img/environment_indoor10.902ab906.jpg";